import React from "react";
import SalesAnalytics from "./sales-analytics";
import SalesOverview from "./sales-overview";

const Component: React.FC = () => {
    return (
        <div className="flex flex-col w-full p-4 gap-y-4">
            <h1 className="text-xl font-medium mb-4">Sales & Revenue</h1>
            <SalesOverview />
            <SalesAnalytics />
        </div>
    );
}

export default Component;